var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusiness3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2240.05 1376.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#91b3fa;}.cls-3{fill:#dce5fe;}.cls-4{fill:#bdd0fb;}.cls-5{fill:#18174a;}.cls-6{fill:url(#linear-gradient-2);}.cls-10,.cls-21,.cls-7,.cls-9{fill:#fff;}.cls-7{opacity:0.73;}.cls-8{opacity:0.43;}.cls-10{opacity:0.54;}.cls-11{opacity:0.52;}.cls-12{fill:#2b69b3;}.cls-13{fill:url(#linear-gradient-3);}.cls-14{fill:url(#linear-gradient-4);}.cls-15{fill:url(#linear-gradient-5);}.cls-16{fill:url(#linear-gradient-6);}.cls-17{fill:url(#linear-gradient-7);}.cls-18{fill:url(#linear-gradient-8);}.cls-19{opacity:0.85;}.cls-20{fill:url(#linear-gradient-9);}.cls-21{opacity:0.62;}.cls-22{fill:#7d97f4;}.cls-23{fill:url(#linear-gradient-10);}.cls-24{fill:url(#linear-gradient-11);}.cls-25{fill:url(#linear-gradient-12);}.cls-26{fill:url(#linear-gradient-13);}.cls-27{fill:url(#linear-gradient-14);}.cls-28{fill:url(#linear-gradient-15);}.cls-29{fill:url(#linear-gradient-16);}.cls-30{fill:url(#linear-gradient-17);}.cls-31{fill:url(#linear-gradient-18);}.cls-32{fill:url(#linear-gradient-19);}.cls-33{fill:url(#linear-gradient-20);}.cls-34{fill:url(#linear-gradient-21);}.cls-35{fill:url(#linear-gradient-22);}.cls-36{fill:url(#linear-gradient-23);}.cls-37{fill:url(#linear-gradient-24);}.cls-38{fill:url(#linear-gradient-25);}.cls-39{fill:url(#linear-gradient-26);}.cls-40{fill:url(#linear-gradient-27);}.cls-41{fill:url(#linear-gradient-28);}.cls-42{fill:url(#linear-gradient-29);}.cls-43{fill:url(#linear-gradient-30);}.cls-44{fill:url(#linear-gradient-31);}.cls-45{fill:url(#linear-gradient-32);}.cls-46{fill:url(#linear-gradient-33);}.cls-47{fill:url(#linear-gradient-34);}.cls-48{fill:url(#linear-gradient-35);}.cls-49{fill:url(#linear-gradient-36);}.cls-50{fill:url(#linear-gradient-37);}.cls-51{fill:url(#linear-gradient-38);}.cls-52{fill:url(#linear-gradient-39);}.cls-53{fill:url(#linear-gradient-40);}.cls-54{fill:url(#linear-gradient-41);}.cls-55{fill:url(#linear-gradient-42);}.cls-56{fill:url(#linear-gradient-43);}.cls-57{fill:url(#linear-gradient-44);}.cls-58{fill:url(#linear-gradient-45);}.cls-59{fill:url(#linear-gradient-46);}.cls-60{fill:url(#linear-gradient-47);}.cls-61{fill:url(#linear-gradient-48);}.cls-62{fill:url(#linear-gradient-49);}.cls-63{fill:url(#linear-gradient-50);}.cls-64{fill:url(#linear-gradient-51);}.cls-65{fill:url(#linear-gradient-52);}.cls-66{fill:url(#linear-gradient-53);}.cls-67{fill:url(#linear-gradient-54);}.cls-68{fill:url(#linear-gradient-55);}.cls-69{fill:url(#linear-gradient-56);}.cls-70{fill:url(#linear-gradient-57);}.cls-71{fill:url(#linear-gradient-58);}.cls-72{fill:url(#linear-gradient-59);}.cls-73{fill:url(#linear-gradient-60);}.cls-74{fill:url(#linear-gradient-61);}.cls-75{fill:url(#linear-gradient-62);}.cls-76{fill:url(#linear-gradient-63);}.cls-77{fill:url(#linear-gradient-64);}.cls-78{fill:url(#linear-gradient-65);}.cls-79{fill:url(#linear-gradient-66);}.cls-80{fill:url(#linear-gradient-67);}.cls-81{fill:url(#linear-gradient-68);}.cls-82{fill:url(#linear-gradient-69);}.cls-83{fill:url(#linear-gradient-70);}.cls-84{fill:url(#linear-gradient-71);}.cls-85{fill:url(#linear-gradient-72);}.cls-86{fill:url(#linear-gradient-73);}.cls-87{fill:url(#linear-gradient-74);}.cls-88{fill:url(#linear-gradient-75);}.cls-89{fill:url(#linear-gradient-76);}.cls-90{fill:url(#linear-gradient-77);}.cls-91{fill:url(#linear-gradient-78);}.cls-92{fill:url(#linear-gradient-79);}.cls-93{fill:url(#linear-gradient-80);}.cls-94{fill:url(#linear-gradient-81);}.cls-95{fill:url(#linear-gradient-82);}.cls-96{fill:url(#linear-gradient-83);}.cls-97{fill:url(#linear-gradient-84);}.cls-98{fill:url(#linear-gradient-85);}.cls-99{fill:url(#linear-gradient-86);}.cls-100{fill:url(#linear-gradient-87);}.cls-101{fill:url(#linear-gradient-88);}.cls-102{fill:url(#linear-gradient-89);}.cls-103{fill:url(#linear-gradient-90);}.cls-104{fill:url(#linear-gradient-91);}.cls-105{fill:url(#linear-gradient-92);}.cls-106{fill:url(#linear-gradient-93);}.cls-107{fill:url(#linear-gradient-94);}.cls-108{fill:url(#linear-gradient-95);}.cls-109{fill:url(#linear-gradient-96);}.cls-110{fill:url(#linear-gradient-97);}.cls-111{fill:url(#linear-gradient-98);}.cls-112{fill:url(#linear-gradient-99);}.cls-113{fill:url(#linear-gradient-100);}.cls-114{fill:url(#linear-gradient-101);}.cls-115{fill:url(#linear-gradient-102);}.cls-116{fill:url(#linear-gradient-103);}.cls-117{fill:url(#linear-gradient-104);}.cls-118{fill:url(#linear-gradient-105);}.cls-119{fill:url(#linear-gradient-106);}.cls-120{fill:url(#linear-gradient-107);}.cls-121{fill:url(#linear-gradient-108);}.cls-122{fill:url(#linear-gradient-109);}.cls-123{fill:url(#linear-gradient-110);}.cls-124{fill:url(#linear-gradient-111);}.cls-125{fill:url(#linear-gradient-112);}.cls-126{fill:url(#linear-gradient-113);}.cls-127{fill:url(#linear-gradient-114);}.cls-128{fill:url(#linear-gradient-115);}.cls-129{fill:url(#linear-gradient-116);}.cls-130{fill:url(#linear-gradient-117);}.cls-131{fill:url(#linear-gradient-118);}.cls-132{fill:url(#linear-gradient-119);}.cls-133{fill:url(#linear-gradient-120);}.cls-134{fill:url(#linear-gradient-121);}.cls-135{fill:url(#linear-gradient-122);}.cls-136{fill:url(#linear-gradient-123);}.cls-137{fill:url(#linear-gradient-124);}.cls-138{fill:url(#linear-gradient-125);}.cls-139{fill:url(#linear-gradient-126);}.cls-140{fill:url(#linear-gradient-127);}.cls-141{fill:url(#linear-gradient-128);}.cls-142{fill:url(#linear-gradient-129);}.cls-143{fill:url(#linear-gradient-130);}.cls-144{fill:url(#linear-gradient-131);}.cls-145{fill:url(#linear-gradient-132);}.cls-146{fill:url(#linear-gradient-133);}.cls-147{fill:url(#linear-gradient-134);}.cls-148{fill:url(#linear-gradient-135);}.cls-149{fill:url(#linear-gradient-136);}.cls-150{fill:url(#linear-gradient-137);}.cls-151{fill:url(#linear-gradient-138);}.cls-152{fill:url(#linear-gradient-139);}.cls-153{fill:url(#linear-gradient-140);}.cls-154{fill:url(#linear-gradient-141);}.cls-155{fill:url(#linear-gradient-142);}.cls-156{fill:url(#linear-gradient-143);}.cls-157{fill:url(#linear-gradient-144);}.cls-158{fill:url(#linear-gradient-145);}.cls-159{fill:url(#linear-gradient-146);}.cls-160{fill:url(#linear-gradient-147);}.cls-161{fill:url(#linear-gradient-148);}.cls-162{fill:url(#linear-gradient-149);}.cls-163{fill:url(#linear-gradient-150);}.cls-164{fill:url(#linear-gradient-151);}.cls-165{fill:url(#linear-gradient-152);}.cls-166{fill:url(#linear-gradient-153);}.cls-167{fill:url(#linear-gradient-154);}.cls-168{fill:url(#linear-gradient-155);}.cls-169{fill:url(#linear-gradient-156);}.cls-170{fill:url(#linear-gradient-157);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1083.22,
    y1: 752.9,
    x2: 761.67,
    y2: 752.9,
    gradientTransform: "matrix(-1.17, 0.14, 0.12, 0.99, 799.33, -74.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1325.98,
    y1: 191.24,
    x2: 899.94,
    y2: 1280.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1973.32,
    y1: 149.79,
    x2: 2036.68,
    y2: 149.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1934.7,
    y1: 151.65,
    x2: 2075.03,
    y2: 151.65,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1778.17,
    y1: 161.72,
    x2: 1809.88,
    y2: 161.72,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1758.84,
    y1: 162.66,
    x2: 1829.07,
    y2: 162.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2031.61,
    y1: 356.03,
    x2: 2071.69,
    y2: 356.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2007.18,
    y1: 357.2,
    x2: 2095.94,
    y2: 357.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 633.98,
    y1: 239.75,
    x2: 443.2,
    y2: 468.11,
    gradientTransform: "translate(396.7 -298.8) rotate(45)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 7834.84,
    y1: 898.02,
    x2: 7874.47,
    y2: 898.02,
    gradientTransform: "translate(-7366.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 7781.71,
    y1: 626.13,
    x2: 7834.55,
    y2: 626.13,
    gradientTransform: "translate(-7366.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 7845.87,
    y1: 852.91,
    x2: 7838.3,
    y2: 918.97,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 7959.66,
    y1: 883.89,
    x2: 7815.49,
    y2: 997.09,
    gradientTransform: "translate(-7366.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 7907.52,
    y1: 859.97,
    x2: 7899.96,
    y2: 926.03,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 8028.79,
    y1: 351.19,
    x2: 7976.09,
    y2: 425.54,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 8006.48,
    y1: 335.38,
    x2: 7953.78,
    y2: 409.73,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 7862.59,
    y1: 425.5,
    x2: 7833.69,
    y2: 550.4,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 4047.26,
    y1: 4277.7,
    x2: 3995.99,
    y2: 4345.54,
    gradientTransform: "translate(-5397.41 416.19) rotate(-46.73)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 3972.16,
    y1: 4331.42,
    x2: 4013.29,
    y2: 4289.23,
    gradientTransform: "translate(-5397.41 416.19) rotate(-46.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 7838.25,
    y1: 454.12,
    x2: 7778.42,
    y2: 564.04,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 7861.69,
    y1: 658.76,
    x2: 7841.39,
    y2: 694.88,
    gradientTransform: "translate(-7366.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -1695.18,
    y1: 1070.06,
    x2: -1575.7,
    y2: 1070.06,
    gradientTransform: "matrix(-1, 0, 0, 1, -1231.54, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -1946.48,
    y1: 1073.71,
    x2: -1808.07,
    y2: 1073.71,
    gradientTransform: "matrix(-1, 0, 0, 1, -1231.54, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -1851.01,
    y1: 923.29,
    x2: -1656.49,
    y2: 923.29,
    gradientTransform: "matrix(-1, 0, 0, 1, -1231.54, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -1847.48,
    y1: 923.29,
    x2: -1660.01,
    y2: 923.29,
    gradientTransform: "matrix(-1, 0, 0, 1, -1231.54, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -1851.01,
    y1: 1024.61,
    x2: -1656.49,
    y2: 1024.61,
    gradientTransform: "matrix(-1, 0, 0, 1, -1231.54, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -1873,
    y1: 1024.61,
    x2: -1640.06,
    y2: 1024.61,
    gradientTransform: "matrix(-1, 0, 0, 1, -1231.54, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -1851.01,
    y1: 1125.94,
    x2: -1656.49,
    y2: 1125.94,
    gradientTransform: "matrix(-1, 0, 0, 1, -1231.54, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -1895.26,
    y1: 1125.94,
    x2: -1619.11,
    y2: 1125.94,
    gradientTransform: "matrix(-1, 0, 0, 1, -1231.54, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -1916.37,
    y1: 1227.27,
    x2: -1656.49,
    y2: 1227.27,
    gradientTransform: "matrix(-1, 0, 0, 1, -1231.54, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -1916.37,
    y1: 1227.27,
    x2: -1602.16,
    y2: 1227.27,
    gradientTransform: "matrix(-1, 0, 0, 1, -1231.54, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -206.95,
    y1: 1135.64,
    x2: -233.62,
    y2: 1188.09,
    gradientTransform: "matrix(-0.98, -0.22, -0.22, 0.98, 1679.46, 102.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#020039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -257.67,
    y1: 1156.51,
    x2: -231.1,
    y2: 1156.51,
    gradientTransform: "matrix(-0.98, -0.22, -0.22, 0.98, 1679.46, 102.05)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -222.43,
    y1: 1188.66,
    x2: -314.89,
    y2: 1309.58,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -268.7,
    y1: 1214.85,
    x2: -197.26,
    y2: 1214.85,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -276.88,
    y1: 1181.03,
    x2: -251.95,
    y2: 1181.03,
    gradientTransform: "matrix(-0.98, -0.22, -0.22, 0.98, 1679.46, 102.05)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -187.14,
    y1: 918.57,
    x2: -100.16,
    y2: 918.57,
    gradientTransform: "matrix(-0.98, -0.22, -0.22, 0.98, 1679.46, 102.05)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 1757.75,
    y1: 848.66,
    x2: 1771.75,
    y2: 963.66,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1935.51,
    y1: 951.43,
    x2: 1829.51,
    y2: 1094.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1689.39,
    y1: 911.94,
    x2: 1769.39,
    y2: 849.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -205.57,
    y1: -1237.37,
    x2: -147.7,
    y2: -1296.74,
    gradientTransform: "matrix(-0.65, -0.76, -0.76, 0.65, 700.95, 1619.2)",
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 1204.49,
    y1: 326.54,
    x2: 1212.64,
    y2: 326.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1218.91,
    y1: 315.81,
    x2: 1227.92,
    y2: 315.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 1235.48,
    y1: 307.34,
    x2: 1245.16,
    y2: 307.34,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1253.61,
    y1: 301.21,
    x2: 1263.79,
    y2: 301.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 1272.77,
    y1: 297.52,
    x2: 1283.3,
    y2: 297.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 1292.48,
    y1: 296.36,
    x2: 1303.22,
    y2: 296.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 1312.24,
    y1: 297.79,
    x2: 1323.02,
    y2: 297.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 1331.49,
    y1: 301.95,
    x2: 1342.14,
    y2: 301.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1349.61,
    y1: 308.9,
    x2: 1359.88,
    y2: 308.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 1365.83,
    y1: 318.51,
    x2: 1375.55,
    y2: 318.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 1379.67,
    y1: 330.33,
    x2: 1388.73,
    y2: 330.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 1390.85,
    y1: 343.87,
    x2: 1399.18,
    y2: 343.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 1399.16,
    y1: 358.67,
    x2: 1406.72,
    y2: 358.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 1404.42,
    y1: 374.33,
    x2: 1411.12,
    y2: 374.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 1406.29,
    y1: 390.43,
    x2: 1412.22,
    y2: 390.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 1403.57,
    y1: 406.47,
    x2: 1410.77,
    y2: 406.47,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 1397.08,
    y1: 421.91,
    x2: 1405.55,
    y2: 421.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 1387.38,
    y1: 436.19,
    x2: 1396.87,
    y2: 436.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1375.37,
    y1: 449.28,
    x2: 1385.59,
    y2: 449.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 1361.82,
    y1: 461.28,
    x2: 1372.54,
    y2: 461.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 1347.34,
    y1: 472.48,
    x2: 1358.35,
    y2: 472.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1332.4,
    y1: 483.22,
    x2: 1343.56,
    y2: 483.22,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 1317.28,
    y1: 493.77,
    x2: 1328.54,
    y2: 493.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 1302.04,
    y1: 504.21,
    x2: 1313.41,
    y2: 504.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 1286.69,
    y1: 514.54,
    x2: 1298.17,
    y2: 514.54,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 1271.25,
    y1: 524.78,
    x2: 1282.83,
    y2: 524.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 1255.75,
    y1: 534.95,
    x2: 1267.42,
    y2: 534.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 1240.19,
    y1: 545.06,
    x2: 1251.95,
    y2: 545.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 1224.59,
    y1: 555.13,
    x2: 1236.43,
    y2: 555.13,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 1208.96,
    y1: 565.17,
    x2: 1220.88,
    y2: 565.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 1193.33,
    y1: 575.2,
    x2: 1205.32,
    y2: 575.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 1177.7,
    y1: 585.23,
    x2: 1189.76,
    y2: 585.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 1162.09,
    y1: 595.28,
    x2: 1174.22,
    y2: 595.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 1146.51,
    y1: 605.36,
    x2: 1158.71,
    y2: 605.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 1130.99,
    y1: 615.5,
    x2: 1143.25,
    y2: 615.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 1115.54,
    y1: 625.7,
    x2: 1127.85,
    y2: 625.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 1100.16,
    y1: 635.98,
    x2: 1112.52,
    y2: 635.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 1084.89,
    y1: 646.36,
    x2: 1097.29,
    y2: 646.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 1069.74,
    y1: 656.84,
    x2: 1082.18,
    y2: 656.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 1054.72,
    y1: 667.46,
    x2: 1067.19,
    y2: 667.46,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 1039.86,
    y1: 678.21,
    x2: 1052.36,
    y2: 678.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 1025.17,
    y1: 689.12,
    x2: 1037.69,
    y2: 689.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 1010.69,
    y1: 700.19,
    x2: 1023.22,
    y2: 700.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 996.44,
    y1: 711.44,
    x2: 1008.93,
    y2: 711.44,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 982.43,
    y1: 722.9,
    x2: 994.86,
    y2: 722.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 968.69,
    y1: 734.55,
    x2: 981.06,
    y2: 734.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 955.23,
    y1: 746.43,
    x2: 967.55,
    y2: 746.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 942.08,
    y1: 758.53,
    x2: 954.33,
    y2: 758.53,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 929.28,
    y1: 770.87,
    x2: 941.44,
    y2: 770.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 916.84,
    y1: 783.45,
    x2: 928.92,
    y2: 783.45,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 904.79,
    y1: 796.28,
    x2: 916.77,
    y2: 796.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 893.16,
    y1: 809.36,
    x2: 905.04,
    y2: 809.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 881.97,
    y1: 822.69,
    x2: 893.74,
    y2: 822.69,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 871.28,
    y1: 836.29,
    x2: 882.92,
    y2: 836.29,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 861.35,
    y1: 850.24,
    x2: 872.76,
    y2: 850.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 852.49,
    y1: 864.64,
    x2: 863.57,
    y2: 864.64,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 845.08,
    y1: 879.56,
    x2: 855.71,
    y2: 879.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 839.55,
    y1: 895.01,
    x2: 849.59,
    y2: 895.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 836.34,
    y1: 910.91,
    x2: 845.63,
    y2: 910.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 835.78,
    y1: 927.03,
    x2: 844.62,
    y2: 927.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 837.55,
    y1: 943.07,
    x2: 847.37,
    y2: 943.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 842.46,
    y1: 958.59,
    x2: 853.33,
    y2: 958.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 850.7,
    y1: 973.05,
    x2: 862.7,
    y2: 973.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 862.43,
    y1: 985.7,
    x2: 875.56,
    y2: 985.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 877.5,
    y1: 995.71,
    x2: 891.58,
    y2: 995.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 895.16,
    y1: 1002.56,
    x2: 909.84,
    y2: 1002.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 914.37,
    y1: 1006.2,
    x2: 929.29,
    y2: 1006.2,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 934.17,
    y1: 1007.04,
    x2: 949.13,
    y2: 1007.04,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 954.01,
    y1: 1005.59,
    x2: 968.89,
    y2: 1005.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 973.54,
    y1: 1002.33,
    x2: 988.3,
    y2: 1002.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 992.62,
    y1: 997.59,
    x2: 1007.24,
    y2: 997.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 1011.18,
    y1: 991.61,
    x2: 1025.62,
    y2: 991.61,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 1029.23,
    y1: 984.73,
    x2: 1043.55,
    y2: 984.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 1046.88,
    y1: 977.21,
    x2: 1061.12,
    y2: 977.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 1064.18,
    y1: 969.19,
    x2: 1078.31,
    y2: 969.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 1081.21,
    y1: 960.76,
    x2: 1095.2,
    y2: 960.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 1097.98,
    y1: 952.01,
    x2: 1111.86,
    y2: 952.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 1114.58,
    y1: 943.04,
    x2: 1128.36,
    y2: 943.04,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 1131.06,
    y1: 933.94,
    x2: 1144.78,
    y2: 933.94,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 1147.5,
    y1: 924.8,
    x2: 1161.17,
    y2: 924.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 1163.95,
    y1: 915.71,
    x2: 1177.62,
    y2: 915.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 1180.52,
    y1: 906.76,
    x2: 1194.17,
    y2: 906.76,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 1197.21,
    y1: 897.97,
    x2: 1210.87,
    y2: 897.97,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 1214.05,
    y1: 889.38,
    x2: 1227.72,
    y2: 889.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 1231.06,
    y1: 881,
    x2: 1244.72,
    y2: 881,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 1248.23,
    y1: 872.85,
    x2: 1261.91,
    y2: 872.85,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 1265.58,
    y1: 864.96,
    x2: 1279.27,
    y2: 864.96,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 1283.11,
    y1: 857.35,
    x2: 1296.82,
    y2: 857.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 1300.85,
    y1: 850.05,
    x2: 1314.57,
    y2: 850.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 1318.78,
    y1: 843.08,
    x2: 1332.53,
    y2: 843.08,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 1336.92,
    y1: 836.48,
    x2: 1350.69,
    y2: 836.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 1355.28,
    y1: 830.27,
    x2: 1369.07,
    y2: 830.27,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 1373.85,
    y1: 824.51,
    x2: 1387.62,
    y2: 824.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 1392.66,
    y1: 819.19,
    x2: 1406.36,
    y2: 819.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 1411.68,
    y1: 814.38,
    x2: 1425.31,
    y2: 814.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 1430.9,
    y1: 810.1,
    x2: 1444.44,
    y2: 810.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 1450.28,
    y1: 806.39,
    x2: 1463.76,
    y2: 806.39,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 1469.84,
    y1: 803.28,
    x2: 1483.23,
    y2: 803.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 1489.54,
    y1: 800.82,
    x2: 1502.84,
    y2: 800.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 1509.36,
    y1: 799.03,
    x2: 1522.55,
    y2: 799.03,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 1529.26,
    y1: 797.93,
    x2: 1542.33,
    y2: 797.93,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 1549.19,
    y1: 797.56,
    x2: 1562.16,
    y2: 797.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 1569.12,
    y1: 798.23,
    x2: 1581.96,
    y2: 798.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 1588.92,
    y1: 800.36,
    x2: 1601.59,
    y2: 800.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 1608.31,
    y1: 804.4,
    x2: 1620.65,
    y2: 804.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 1626.82,
    y1: 810.77,
    x2: 1638.58,
    y2: 810.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 1643.72,
    y1: 819.8,
    x2: 1654.58,
    y2: 819.8,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 1658.16,
    y1: 831.36,
    x2: 1667.84,
    y2: 831.36,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 1669.09,
    y1: 845.19,
    x2: 1677.2,
    y2: 845.19,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 1675.22,
    y1: 860.74,
    x2: 1681.36,
    y2: 860.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 1674.89,
    y1: 876.84,
    x2: 1681.01,
    y2: 876.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 1669.12,
    y1: 892.39,
    x2: 1676.29,
    y2: 892.39,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 1660.06,
    y1: 906.87,
    x2: 1667.84,
    y2: 906.87,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 1648.89,
    y1: 920.31,
    x2: 1656.96,
    y2: 920.31,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 1636.4,
    y1: 932.91,
    x2: 1644.55,
    y2: 932.91,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 1623.1,
    y1: 944.95,
    x2: 1631.22,
    y2: 944.95,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1530.65,66.74c141.43,106.71,563.95-82.58,586.82,143.19,26.78,264.37-395.29,394.62-232.93,562.91s33.4,394.87-528.59,459.49S-137.74,1174.59,49.05,895.38,89.26,620.92,65,510.56,121,141.84,580.79,293,1172.5-203.48,1530.65,66.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2234.55,740.94c-.55-5.22-9.49-6.87-12.05-2.23-24.76,44.93-94.48,160.86-181.25,214.48-141.28,87.31-252.14,247.89-187.68,350.4C1853.57,1303.59,2293.89,1309.41,2234.55,740.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2211.35,807c-.45,1.68-.95,2.9-1.43,4.32l-1.52,4.08-3.15,8.1c-2.14,5.38-4.38,10.73-6.63,16.06-4.51,10.68-9.25,21.24-14,31.79-9.72,21-20.07,41.77-30.86,62.28a1263,1263,0,0,1-71.48,119.25c-13,19.21-26.81,37.86-41,56.17s-29.36,36-45,53.07q-23.75,25.47-49.64,48.78c-8.85,7.52-17.56,15.18-26.81,22.2-9,7.34-18.57,13.89-28,20.64a1,1,0,0,1-1.18-1.6l0,0c18.44-13.91,36.22-28.62,53.17-44.27s33-32.19,48.47-49.33,30.24-34.82,44.37-53.06,27.58-37,40.69-56,25.5-38.47,37.5-58.19l8.9-14.85,8.68-15c5.73-10,11.44-20.06,17-30.2q16.62-30.39,31.76-61.58c5-10.39,10-20.81,14.78-31.34q3.57-7.89,7-15.83l3.4-8,1.64-4c.51-1.31,1.1-2.76,1.47-3.86l.09-.27a1,1,0,0,1,1.87.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2110.87,241.54c-1.49-8-12.79-8.75-15.24-.95C2072,316.06,2003.86,512,1905,614.12c-161,166.26-273.11,440.69-177.51,587.41C1727.45,1201.53,2272.56,1118,2110.87,241.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2092.22,349.68c-.27,2.39-.69,4.45-1.06,6.64l-1.21,6.45-2.56,12.86c-1.76,8.56-3.64,17.1-5.53,25.64q-5.76,25.58-12.09,51c-8.45,33.93-17.78,67.64-27.63,101.19s-20.53,66.87-31.92,99.94-23.33,66-36.31,98.45c-25.8,65-55.05,128.77-88.71,190.16-2.06,3.87-4.23,7.66-6.43,11.45l-6.56,11.37-6.56,11.37c-2.23,3.76-4.57,7.47-6.85,11.2-4.62,7.43-9.07,15-13.83,22.31l-14.42,21.94a920.62,920.62,0,0,1-63.77,83.34,1,1,0,0,1-1.52-1.28h0a998.23,998.23,0,0,0,61.85-84.33l14.11-22c4.66-7.37,9-14.93,13.52-22.38,2.23-3.75,4.51-7.47,6.69-11.24l6.4-11.4,6.4-11.4c2.15-3.8,4.27-7.6,6.27-11.48,16.66-30.64,32-62,46.7-93.6s28-63.88,41.12-96.22c25.93-64.78,48.49-130.89,69-197.61Q2052.65,502,2066,451.34q6.7-25.32,12.9-50.76,3.06-12.72,6-25.49l2.83-12.78,1.35-6.4c.41-2.11.88-4.33,1.16-6.27l0-.22a1,1,0,0,1,1.95.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M290.5,1242.51A29.54,29.54,0,0,0,320,1271.94H1913.12a29.53,29.53,0,0,0,29.46-29.43L1955.84,327c0-16.19-19.07-47.79-54-45.42l-1557-40.28a74.24,74.24,0,0,0-76.18,75.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M319.59,1214.27a28,28,0,0,0,27.87,27.87H1874.7a28,28,0,0,0,27.87-27.87l12.51-831.14c-1.47-50-45.32-68-71.9-66.93l-1492.26-40a52.17,52.17,0,0,0-53.53,53.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1886.07,819.11H1886a3.78,3.78,0,0,1-3.72-3.83l1-67.41a3.88,3.88,0,0,1,3.83-3.72,3.77,3.77,0,0,1,3.72,3.84l-1,67.4A3.78,3.78,0,0,1,1886.07,819.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1888.5,653.93h-.06a3.78,3.78,0,0,1-3.72-3.83l3.79-258.16c-.07-15.43-4.76-27.74-13.93-36.53-17.09-16.38-44.21-15.53-45.37-15.5l-476.94-12.79a3.78,3.78,0,0,1,.1-7.55h.11l476.67,12.78c3-.14,31.6-.66,50.65,17.59,10.71,10.26,16.18,24.4,16.26,42l-3.79,258.23A3.78,3.78,0,0,1,1888.5,653.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 161.25,
    y: 1267.5,
    width: 1878.27,
    height: 80.44,
    rx: 7.34,
    transform: "translate(2200.78 2615.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M609.67,742.42H443.4a39.74,39.74,0,0,0-39.7,41.69l18.92,386.41a39.75,39.75,0,0,0,39.7,37.81H609.67a39.75,39.75,0,0,0,39.75-39.75V782.17A39.75,39.75,0,0,0,609.67,742.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1009.58,391.81l-583.52,9A39.75,39.75,0,0,0,387,442.51l9.72,198.43a39.74,39.74,0,0,0,39.7,37.8H1010.2A39.75,39.75,0,0,0,1050,639V431.55A39.75,39.75,0,0,0,1009.58,391.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 698.71,
    y: 742.42,
    width: 351.24,
    height: 465.91,
    rx: 39.75
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 1246.84,
    cy: 500.06,
    r: 99.82,
    transform: "translate(659.65 1708.31) rotate(-85.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 1494.91,
    cy: 500.06,
    r: 99.82,
    transform: "translate(941.88 1976.19) rotate(-87.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 1742.98,
    cy: 503.32,
    r: 99.81,
    transform: "translate(154.6 1379.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1306.15,479a64.12,64.12,0,1,1-59.31-39.75c1.09,0,2.16,0,3.24.08V423c-1.08,0-2.15-.07-3.24-.07a80.31,80.31,0,1,0,74.22,49.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1528,557.57a64.11,64.11,0,1,1-34.16-118.36c1.09,0,2.17,0,3.24.08V423c-1.08,0-2.15-.07-3.24-.07A80.36,80.36,0,1,0,1536,571.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1796.48,539.37a64.11,64.11,0,1,1-53-100.16c1.09,0,2.16,0,3.24.08V423c-1.08,0-2.15-.07-3.24-.07a80.36,80.36,0,1,0,66.18,125.93Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1328.17,642.15H1165.51a18.49,18.49,0,0,0,0,37h162.66a18.49,18.49,0,0,0,0-37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1576.24,642.15H1413.58a18.49,18.49,0,0,0,0,37h162.66a18.49,18.49,0,1,0,0-37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1661.65,679.13h162.66a18.49,18.49,0,0,0,0-37H1661.65a18.49,18.49,0,0,0,0,37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1147.03,
    y: 699.67,
    width: 199.63,
    height: 145.83,
    rx: 18.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1395.1,
    y: 699.67,
    width: 199.63,
    height: 145.83,
    rx: 18.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1643.17,
    y: 699.67,
    width: 199.63,
    height: 145.83,
    rx: 18.49
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M730.37,991.16v146.7a41.54,41.54,0,0,0,41.53,41.53H972.82a42.66,42.66,0,0,0,42.66-42.65V915.86c0-18.59-23-27.35-35.35-13.5l-38.82,43.39a42.81,42.81,0,0,1-58,5.39l-3.72-2.86a36.63,36.63,0,0,0-46.07,1.13l-21.27,18.08a56.2,56.2,0,0,1-58.93,8.67h0A16.38,16.38,0,0,0,730.37,991.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1161.28,
    y: 1055.92,
    width: 29.29,
    height: 152.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1217.55,
    y: 1108.3,
    width: 33.67,
    height: 100.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1273.81,
    y: 978.85,
    width: 33.67,
    height: 229.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1330.08,
    y: 1153.2,
    width: 33.67,
    height: 55.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1386.34,
    y: 1009.53,
    width: 33.67,
    height: 198.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1442.61,
    y: 1043.95,
    width: 33.67,
    height: 164.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1494.49,
    y: 1081.36,
    width: 33.67,
    height: 126.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1550.76,
    y: 932.45,
    width: 33.67,
    height: 275.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1607.02,
    y: 961.63,
    width: 33.67,
    height: 246.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1663.29,
    y: 1005.78,
    width: 33.67,
    height: 202.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1719.55,
    y: 1158.31,
    width: 33.67,
    height: 50.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1775.82,
    y: 1061.16,
    width: 33.67,
    height: 147.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1245,932.45H1096.85a11.79,11.79,0,0,0,0,23.57H1245a11.79,11.79,0,0,0,0-23.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1245,895.57H1096.85a11.79,11.79,0,0,0,0,23.57H1245a11.79,11.79,0,0,0,0-23.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1512.31,932.45H1364.15a11.79,11.79,0,1,0,0,23.57h148.16a11.79,11.79,0,1,0,0-23.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1512.31,895.57H1364.15a11.79,11.79,0,1,0,0,23.57h148.16a11.79,11.79,0,1,0,0-23.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M6.46,874.75c58.42,15.72,394.64,121,352.48,454.3,0,0-239.2-12.36-358.75-448A5.12,5.12,0,0,1,6.46,874.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.67,921.77c30.49,23.83,60.2,48.57,89.44,73.87S192,1047,219.84,1073.83s54.89,54.6,80.42,83.78q19.22,21.81,36.82,45.06a488.68,488.68,0,0,1,32.63,48.42,4,4,0,0,1-6.87,4l0,0h0a482.86,482.86,0,0,0-31.64-48q-17.15-23.14-36.06-45c-25.06-29.23-51.75-57.1-79.23-84.18s-55.83-53.27-84.74-78.84S72.76,948.48,42.6,924.43h0a1.69,1.69,0,0,1,2.09-2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.91,179.25c92.65,83,612.09,588.33,225.49,1160.94,0,0-427.6-244.62-242.84-1155.23A10.53,10.53,0,0,1,145.91,179.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M180.75,317.67c17.61,37.74,33.7,76.07,49.23,114.66s30,77.56,43.86,116.8,26.77,78.76,38.78,118.59l4.51,14.94,4.33,15c2.86,10,5.84,20,8.5,30l8.15,30.12L345.79,788q2,7.56,3.69,15.17l3.57,15.19,3.56,15.19,3.3,15.26c2.14,10.18,4.44,20.33,6.45,30.54l5.9,30.66c1,5.1,1.87,10.23,2.73,15.36l2.61,15.4,2.6,15.39,2.25,15.46c1.43,10.31,3.07,20.59,4.33,30.93l3.63,31c.66,5.16,1.1,10.35,1.54,15.54l1.37,15.56,1.36,15.57.9,15.6.87,15.61c.25,5.2.68,10.4.71,15.61l.67,31.26a1015.22,1015.22,0,0,1-6.92,124.92,4,4,0,1,1-7.9-1v-.07a1008.36,1008.36,0,0,0,7.43-123.85l-.52-31.06c0-5.18-.41-10.35-.64-15.53l-.79-15.52-.83-15.52-1.28-15.49-1.29-15.49c-.42-5.17-.82-10.33-1.46-15.48l-3.47-30.9c-1.21-10.3-2.8-20.55-4.18-30.83l-2.16-15.4-2.53-15.35-2.52-15.35c-.84-5.12-1.65-10.24-2.66-15.33l-5.74-30.58c-1.95-10.19-4.2-20.32-6.29-30.48l-3.21-15.23-3.49-15.17-3.49-15.17q-1.69-7.59-3.61-15.14l-7.52-30.21-8-30.09c-2.6-10-5.53-20-8.34-30l-4.25-15-4.44-14.93q-17.7-59.7-38.16-118.57T226.32,433.79c-15.33-38.59-31.25-77-48.61-114.67v0a1.68,1.68,0,1,1,3.05-1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2027.41,27.38a1.94,1.94,0,0,0-2.12.72l-13.76,19a102.45,102.45,0,0,0-33,3.24l-17.19-16a1.94,1.94,0,0,0-2.23-.28L1934.3,47.38a1.91,1.91,0,0,0-1,2l3.7,23.17a102.6,102.6,0,0,0-21,25.62l-23.45.88a1.93,1.93,0,0,0-1.78,1.36l-8.17,27a1.91,1.91,0,0,0,.71,2.12l19,13.77a102.1,102.1,0,0,0,3.23,33l-16,17.2a1.94,1.94,0,0,0-.28,2.22l13.27,24.83a1.93,1.93,0,0,0,2,1l23.16-3.71a102.38,102.38,0,0,0,25.62,21l.88,23.46a1.93,1.93,0,0,0,1.36,1.77l27,8.18a1.93,1.93,0,0,0,2.12-.72l13.77-19a102.39,102.39,0,0,0,33-3.24l17.2,16a1.92,1.92,0,0,0,2.22.28l24.83-13.27a1.92,1.92,0,0,0,1-2L2073,227a102.16,102.16,0,0,0,21-25.62l23.46-.87a1.94,1.94,0,0,0,1.77-1.37l8.18-27a1.92,1.92,0,0,0-.72-2.12l-19-13.77a102.11,102.11,0,0,0-3.24-33l16-17.2a1.94,1.94,0,0,0,.29-2.22l-13.28-24.83a1.91,1.91,0,0,0-2-1l-23.17,3.71a102.16,102.16,0,0,0-25.61-21l-.88-23.46a1.93,1.93,0,0,0-1.37-1.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1987.33,123.47a31.7,31.7,0,1,1-3.66,2.87A31,31,0,0,1,1987.33,123.47ZM2015.18,165a19,19,0,0,0,2.14-1.68,18.23,18.23,0,1,0-2.14,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1965.68,92.15a70.06,70.06,0,0,1,6.11-3.67l1-.53a71.06,71.06,0,0,1,12.84-5.09,2.24,2.24,0,0,1,2.46.9,2.59,2.59,0,0,1,.29.63,2.23,2.23,0,0,1-1.53,2.76,66.42,66.42,0,0,0-13,5.26h0a65.75,65.75,0,0,0-28.09,86.76c.36.73.73,1.45,1.11,2.17a64.61,64.61,0,0,0,3.45,5.74,65.72,65.72,0,0,0,112.46-67.69,64.66,64.66,0,0,0-3.44-5.72A65.54,65.54,0,0,0,2038.71,94a2.17,2.17,0,0,1-.71-.67,2.23,2.23,0,0,1,3-3.15,69.91,69.91,0,0,1,22.08,21q2,3,3.68,6.11a70.18,70.18,0,0,1-120.1,72.28,68.1,68.1,0,0,1-3.68-6.13A70.27,70.27,0,0,1,1965.68,92.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1805.24,100.46a1,1,0,0,0-1.06.36l-6.89,9.52a50.87,50.87,0,0,0-16.5,1.62l-8.61-8a1,1,0,0,0-1.11-.14l-12.43,6.64a1,1,0,0,0-.5,1l1.86,11.6a50.86,50.86,0,0,0-10.51,12.82l-11.74.44a1,1,0,0,0-.89.68l-4.09,13.49a1,1,0,0,0,.35,1.06l9.52,6.89a51.17,51.17,0,0,0,1.62,16.5l-8,8.61a1,1,0,0,0-.14,1.11l6.64,12.43a1,1,0,0,0,1,.49l11.59-1.85a51,51,0,0,0,12.82,10.51l.44,11.74a1,1,0,0,0,.68.89L1782.8,223a1,1,0,0,0,1.06-.35l6.89-9.52a51.12,51.12,0,0,0,16.5-1.62l8.61,8a1,1,0,0,0,1.11.14L1829.4,213a1,1,0,0,0,.5-1L1828,200.37a51.3,51.3,0,0,0,10.52-12.82l11.74-.44a1,1,0,0,0,.88-.68l4.1-13.49a1,1,0,0,0-.36-1.06L1845.4,165a50.84,50.84,0,0,0-1.62-16.5l8-8.61a1,1,0,0,0,.14-1.11l-6.64-12.43a1,1,0,0,0-1-.5l-11.6,1.86a51.12,51.12,0,0,0-12.82-10.52l-.44-11.74a1,1,0,0,0-.68-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1785.18,148.55a15.89,15.89,0,1,1-1.83,1.44A16.53,16.53,0,0,1,1785.18,148.55Zm13.94,20.79a9.4,9.4,0,0,0,1.07-.84,9.17,9.17,0,1,0-13-.61,9.19,9.19,0,0,0,11.88,1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1774.34,132.88c1-.66,2-1.27,3.06-1.84l.51-.27a36,36,0,0,1,6.42-2.54,1.12,1.12,0,0,1,1.24.45,1,1,0,0,1,.14.32,1.1,1.1,0,0,1-.76,1.37,32.86,32.86,0,0,0-6.49,2.64h0a32.88,32.88,0,0,0-14.06,43.42c.18.36.36.72.55,1.08a30.32,30.32,0,0,0,1.73,2.87A32.89,32.89,0,0,0,1823,146.51a30.51,30.51,0,0,0-1.72-2.86,32.65,32.65,0,0,0-10.35-9.84,1.1,1.1,0,0,1-.35-.33,1.13,1.13,0,0,1,0-1.2,1.11,1.11,0,0,1,1.53-.38,35.07,35.07,0,0,1,11,10.5c.66,1,1.28,2,1.84,3.06a35.12,35.12,0,0,1-60.1,36.17,32.36,32.36,0,0,1-1.84-3.07A35.16,35.16,0,0,1,1774.34,132.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2065.83,278.6a1.24,1.24,0,0,0-1.35.45l-8.7,12a64.63,64.63,0,0,0-20.86,2.05L2024,283a1.21,1.21,0,0,0-1.4-.19l-15.71,8.4a1.22,1.22,0,0,0-.63,1.27l2.35,14.65a64.63,64.63,0,0,0-13.29,16.2l-14.84.56a1.22,1.22,0,0,0-1.12.86l-5.17,17a1.21,1.21,0,0,0,.45,1.34l12,8.71a64.82,64.82,0,0,0,2,20.85l-10.09,10.88a1.21,1.21,0,0,0-.18,1.41l8.39,15.7a1.22,1.22,0,0,0,1.27.63l14.65-2.34A64.72,64.72,0,0,0,2019,412.31l.55,14.84a1.22,1.22,0,0,0,.87,1.12l17,5.17a1.22,1.22,0,0,0,1.34-.45l8.71-12a64.63,64.63,0,0,0,20.86-2l10.87,10.1a1.25,1.25,0,0,0,1.41.18l15.71-8.4a1.22,1.22,0,0,0,.63-1.27l-2.35-14.65a64.63,64.63,0,0,0,13.29-16.2l14.84-.56a1.22,1.22,0,0,0,1.12-.86l5.17-17.05a1.23,1.23,0,0,0-.45-1.34l-12-8.71a64.53,64.53,0,0,0-2-20.85l10.09-10.88a1.23,1.23,0,0,0,.18-1.41l-8.39-15.7a1.22,1.22,0,0,0-1.27-.63L2100.49,313a64.85,64.85,0,0,0-16.2-13.29l-.56-14.84a1.2,1.2,0,0,0-.86-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M2040.47,339.38a20,20,0,1,1-2.31,1.81A19.76,19.76,0,0,1,2040.47,339.38Zm17.62,26.27a12.33,12.33,0,0,0,1.35-1.06,11.6,11.6,0,1,0-8.34,3A11.48,11.48,0,0,0,2058.09,365.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2026.77,319.57q1.86-1.24,3.87-2.33l.64-.33a44.57,44.57,0,0,1,8.12-3.22,1.42,1.42,0,0,1,1.56.57,1.44,1.44,0,0,1,.18.4,1.4,1.4,0,0,1-1,1.74,42.1,42.1,0,0,0-8.2,3.33h0a41.58,41.58,0,0,0-17.77,54.88c.23.46.46.92.7,1.37q1,1.89,2.19,3.63a41.56,41.56,0,0,0,71.13-42.81,39.83,39.83,0,0,0-2.17-3.62A41.52,41.52,0,0,0,2073,320.75a1.4,1.4,0,0,1-.45-.42,1.41,1.41,0,0,1,1.9-2,44.3,44.3,0,0,1,14,13.28c.83,1.24,1.61,2.53,2.32,3.86a44.39,44.39,0,0,1-76,45.72,42.83,42.83,0,0,1-2.33-3.88A44.45,44.45,0,0,1,2026.77,319.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M360.46,604.61a9.27,9.27,0,1,0,9.2-9.33A9.25,9.25,0,0,0,360.46,604.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M360.77,604.61a9,9,0,1,0,8.9-9A9,9,0,0,0,360.77,604.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M377.09,602.77a2,2,0,0,1-1.77-1.09,6.27,6.27,0,0,0-5.59-3.41,5.82,5.82,0,0,0-1.18.1,2,2,0,1,1-.74-3.9,9.41,9.41,0,0,1,1.84-.18h.07a10.22,10.22,0,0,1,9.14,5.58,2,2,0,0,1-1.77,2.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 369.72,
    cy: 660.73,
    r: 9.27,
    transform: "matrix(0.29, -0.96, 0.96, 0.29, -369.79, 823.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M360.77,660.78a9,9,0,1,0,8.9-9A8.95,8.95,0,0,0,360.77,660.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M377.09,658.94a2,2,0,0,1-1.77-1.08,6.27,6.27,0,0,0-5.59-3.42,7.73,7.73,0,0,0-1.18.11,2,2,0,0,1-.74-3.91,10.24,10.24,0,0,1,1.84-.17h.07a10.22,10.22,0,0,1,9.14,5.58,2,2,0,0,1-1.77,2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M360.46,717a9.27,9.27,0,1,0,9.2-9.33A9.26,9.26,0,0,0,360.46,717Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M360.77,717a9,9,0,1,0,8.9-9A8.95,8.95,0,0,0,360.77,717Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M377.09,715.12a2,2,0,0,1-1.77-1.08,6.44,6.44,0,0,0-5.64-3.42,7.09,7.09,0,0,0-1.13.11,2,2,0,1,1-.74-3.9,9.53,9.53,0,0,1,1.92-.18,10.23,10.23,0,0,1,9.13,5.57,2,2,0,0,1-1.77,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M346.2,604.13l0,1.57c-.12,4.28-2.79,7.67-6.05,7.68l-248.2.38c-3.37,0-6.11-3.56-6.1-8h0c0-4.32,2.65-7.85,6-7.94l248.25-2C343.5,595.79,346.33,599.56,346.2,604.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M346.2,660l0,1.58c-.12,4.27-2.79,7.66-6.05,7.68l-248.2.37c-3.37,0-6.11-3.56-6.1-8h0c0-4.33,2.65-7.86,6-8l248.25-2C343.5,651.7,346.33,655.46,346.2,660Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M346.2,715.94l0,1.57c-.12,4.28-2.79,7.67-6.05,7.68l-248.2.38c-3.37,0-6.11-3.56-6.1-8h0c0-4.33,2.65-7.85,6-7.94l248.25-2C343.5,707.6,346.33,711.37,346.2,715.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M418.08,96.17l705.39-11.92c28.4-.48,51.2,23.87,49.51,52.9L1148.7,554.69c-1.33,22.85-19.71,40.75-42.07,41l-678.05,6.71c-16.75.17-30.59-13.34-31.23-30.47L381.13,136.12C380.33,114.55,397,96.52,418.08,96.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M428.89,106.8l687-11.34a47.52,47.52,0,0,1,48.21,50.33L1140.44,543a41.44,41.44,0,0,1-41,39l-660.36,6.38a30.14,30.14,0,0,1-30.4-29l-15.8-414.61A36.62,36.62,0,0,1,428.89,106.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M441.74,120.5l654.17-10.8a45.23,45.23,0,0,1,45.91,47.92L1119.3,535.9a39.46,39.46,0,0,1-39,37.12L451.47,579.1a28.7,28.7,0,0,1-29-27.61l-15-394.8A34.87,34.87,0,0,1,441.74,120.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1117.46,95.13,427.6,106.52a36.79,36.79,0,0,0-36.14,38.17l1.12,29.23H1164.2l1.68-28.24A47.72,47.72,0,0,0,1117.46,95.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M449.3,120.65a6.21,6.21,0,1,1-6.21-6.2A6.2,6.2,0,0,1,449.3,120.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M449.3,138.83a6.21,6.21,0,1,1-6.21-6.2A6.21,6.21,0,0,1,449.3,138.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M449.3,157a6.21,6.21,0,1,1-6.21-6.2A6.21,6.21,0,0,1,449.3,157Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 559.03,
    cy: 329.46,
    r: 98.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 559.03,
    cy: 329.46,
    r: 21.68,
    transform: "translate(-69.23 491.79) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M611.74,365a63.16,63.16,0,1,1-52.23-98.68c1.06,0,2.13,0,3.18.08v-16c-1.06,0-2.12-.07-3.18-.07a79.17,79.17,0,1,0,65.2,124.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M732.5,254.68a14.41,14.41,0,1,1-14.32-14.5A14.41,14.41,0,0,1,732.5,254.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M732,254.68a13.93,13.93,0,1,1-13.84-14A13.93,13.93,0,0,1,732,254.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M705.25,253.82a12.36,12.36,0,0,1,.2-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M706.64,248.72a12.83,12.83,0,0,1,11.53-7,12.67,12.67,0,0,1,2.32.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M732.5,342a14.41,14.41,0,1,1-14.32-14.51A14.41,14.41,0,0,1,732.5,342Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M732,342a13.93,13.93,0,1,1-13.84-14A13.93,13.93,0,0,1,732,342Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M705.25,341.17a12.36,12.36,0,0,1,.2-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M706.64,336.07a12.86,12.86,0,0,1,11.53-7,13.61,13.61,0,0,1,2.32.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M732.5,429.38a14.41,14.41,0,1,1-14.32-14.51A14.42,14.42,0,0,1,732.5,429.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M732,429.37a13.93,13.93,0,1,1-13.84-14A13.93,13.93,0,0,1,732,429.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M705.25,428.51a12.42,12.42,0,0,1,.2-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M706.64,423.42a12.86,12.86,0,0,1,11.53-7,12.67,12.67,0,0,1,2.32.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M754.66,253.93l.07,2.45c.18,6.65,4.33,11.92,9.4,11.94l280.36.59c5.24,0,9.49-5.54,9.48-12.4h0c0-6.73-4.12-12.22-9.25-12.36l-280.43-3C758.87,241,754.47,246.83,754.66,253.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M754.66,340.85l.07,2.46c.18,6.64,4.33,11.91,9.4,11.94l280.36.58c5.24,0,9.49-5.54,9.48-12.4h0c0-6.73-4.12-12.22-9.25-12.35l-280.43-3C758.87,327.89,754.47,333.75,754.66,340.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M754.66,427.77l.07,2.46c.18,6.64,4.33,11.91,9.4,11.94l280.36.58c5.24,0,9.49-5.53,9.48-12.4h0c0-6.73-4.12-12.22-9.25-12.35l-280.43-3C758.87,414.82,754.47,420.67,754.66,427.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1071.18,496.29,469.31,507a17.38,17.38,0,0,0-16.85,20.12l2.65,16.61a17.39,17.39,0,0,0,17.23,14.64L1068.91,556a17.37,17.37,0,0,0,17.21-15.54l2.66-24.94A17.4,17.4,0,0,0,1071.18,496.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M507.86,912.13a3.42,3.42,0,0,0-.1-.89c-4.46-17.7-26.61-28.72-26.61-28.72l-8.78.69c-5.05,15.59-4.4,25.16-3.59,29.42,0,.12.06.23.09.35A207.88,207.88,0,0,0,507.86,912.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M468.87,913a3.58,3.58,0,0,0,2.37,2.81c8.76,2.17,22.67.42,28.52-.47a3.1,3.1,0,0,0,2.25-3.19A150.33,150.33,0,0,1,468.87,913Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M434.11,598.89c-5.42,5.79-13.4,10.79-19,13.91,8.39,10.37,19.74,20.75,34.77,30.92l4.3,9.65,13.78-16.52S443.21,624.55,434.11,598.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M468.84,870.13l3.72,17.9a2.93,2.93,0,0,0,2.5,2.41,25.05,25.05,0,0,0,5.76-.09,3.68,3.68,0,0,0,2.91-4.33l-2.58-15.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M545.87,912.8c-9.69-.27-14.71-1.41-17.3-2.47,0,1,0,1.94,0,3a1.91,1.91,0,0,0,1.83,1.94l53.23-.34a2.43,2.43,0,0,0,2-3.54C578.63,911.93,560.86,913.22,545.87,912.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M585.61,911.35a2.56,2.56,0,0,0-.21-.4c-4.7-6.57-16.67-19.65-40.33-25.32l-11.35-.36s-5.05,8.78-5.15,25.06c2.59,1.06,7.61,2.2,17.3,2.47C560.86,913.22,578.63,911.93,585.61,911.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M531.62,868.07c.12.85,1.68,13.7,2.28,18.69A2.47,2.47,0,0,0,536,889a26.07,26.07,0,0,0,7.8-.12,3.36,3.36,0,0,0,2.54-3.37V865.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M522.51,633.41s27.37,104,26.88,235a5.09,5.09,0,0,1-4,4.94,59.19,59.19,0,0,1-12.69,1.46,4.69,4.69,0,0,1-4.48-3.92c-3.84-22.51-25.87-149.32-38.42-169.91,0,0-8.26,112.94-5.62,171.54a2.77,2.77,0,0,1-2.45,2.89,47.3,47.3,0,0,1-10.19,0,3.74,3.74,0,0,1-3.31-3.16c-2.73-19-18.47-132.45-17.8-214.13,0-4.61,12.18-24.64,12.18-24.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M612,409.38c-12,22.36-32,45.19-64.42,51.31-30,5.64-83.76,12.62-105.39,15.34a26.52,26.52,0,0,0-16.74,9c-17,19.67-54.29,73.52-10.39,127.78,5.62-3.12,13.6-8.12,19-13.91-4.85-13.69-5.25-31.18,4.93-52.64a46,46,0,0,0,1.3,5c14,44.45,14.77,81.43,14.74,90a2.81,2.81,0,0,0,1.77,2.63c18.46,7.4,54,3,65.93,1.22a4,4,0,0,0,3.36-4.55c-5.86-42.42,24.19-112.21,32.13-129.68a11.56,11.56,0,0,1,5.76-5.77c45.39-20.53,65.12-52.14,73.12-80.61C630.23,415.19,619.51,411.13,612,409.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M637.15,424.48c9.7-34.51,2.15-64.42,2.15-64.42H629A167.24,167.24,0,0,1,612,409.38C619.51,411.13,630.23,415.19,637.15,424.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M632.6,365.57s-15.74-20.39-10.62-31S644.63,325,644.63,325l2.45,8.32a10.51,10.51,0,0,1-.24,6.67l-9.69,25.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M474.13,435.22l-3.56,36.36s20.45,6.16,35.33-4.34l-10.46-33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M497.86,393.79c.49.46,20.78,40.29,20.78,40.29l-23,11.1-24.83-34.9S489.62,386,497.86,393.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M481,411.25a3.69,3.69,0,0,0,.27,3.22l11.47,19.11a3.37,3.37,0,0,0,.63.78c1.36,1.27,6,5,9.64-.06,3.08-4.29,6-8.19,9.06-9.79a3.66,3.66,0,0,1,4.94,1.62,137.18,137.18,0,0,1,7.85,18.62,3.64,3.64,0,0,1-2.12,4.47c-4.66,1.89-13.86,5.3-22,6.42a3.67,3.67,0,0,1-3.47-1.47c-3.51-4.81-13.41-18.26-16.79-21.62-3.13-3.13-8.93-1.95-11.54-1.2A3.68,3.68,0,0,1,466,431c-2.65-1.6-7.27-5.57-3-12.3a3.66,3.66,0,0,0-1.13-5c-3-1.95-6.17-5.6-3.11-11.51s8.62-6.52,12.38-6.06a3.82,3.82,0,0,0,4-2.22,2.4,2.4,0,0,1,1.89-1.49,3.56,3.56,0,0,0,2.88-4.18c-.66-3.39-.16-7.79,5.24-10.76C495,372,503.7,380.9,505.91,388.4s-8.88,12.8-15.86,13.68C484.93,402.73,482.12,408.33,481,411.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M484.76,439.57s-4.41-12.91-10.06-12.43-10.08,6.09-3.09,12.42C480.31,447.42,484.76,439.57,484.76,439.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M437.17,542.93c-7.44-20.37-4.74-45-4.71-45.2l2.05.23c0,.24-2.67,24.36,4.6,44.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M488.77,698.29a1,1,0,0,1-1-.78c-2.27-8.75-19.27-18.37-19.44-18.47a1,1,0,1,1,1-1.8c.73.41,17.93,10.15,20.42,19.76a1,1,0,0,1-.74,1.25A.75.75,0,0,1,488.77,698.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M351,1356.35a6.64,6.64,0,0,0,6.71-5.07L463.54,790.87c.63-3.31-1.87-6.45-5.58-7s-7.21,1.67-7.84,5l-105.87,560.4c-.62,3.32,1.88,6.45,5.58,7A7.49,7.49,0,0,0,351,1356.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M708.13,1356.35a7.87,7.87,0,0,0,1.35-.12c3.68-.67,6.07-3.87,5.33-7.16L590,796c-.75-3.29-4.33-5.44-8-4.76s-6.07,3.87-5.33,7.16l124.8,553.12A6.67,6.67,0,0,0,708.13,1356.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M431.75,929.36H612.67c3.75,0,6.8-2.72,6.8-6.07s-3.05-6.08-6.8-6.08H431.75c-3.76,0-6.8,2.72-6.8,6.08S428,929.36,431.75,929.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M435,929.36H609.38a6.09,6.09,0,1,0,0-12.15H435a6.09,6.09,0,1,0,0,12.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M431.75,1030.69H612.67c3.75,0,6.8-2.72,6.8-6.08s-3.05-6.08-6.8-6.08H431.75c-3.76,0-6.8,2.73-6.8,6.08S428,1030.69,431.75,1030.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M415.33,1030.69H634.66c3.76,0,6.8-2.72,6.8-6.08s-3-6.08-6.8-6.08H415.33c-3.76,0-6.81,2.73-6.81,6.08S411.57,1030.69,415.33,1030.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M431.75,1132H612.67c3.75,0,6.8-2.72,6.8-6.08s-3.05-6.08-6.8-6.08H431.75c-3.76,0-6.8,2.72-6.8,6.08S428,1132,431.75,1132Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M394.38,1132H656.91c3.76,0,6.81-2.72,6.81-6.08s-3.05-6.08-6.81-6.08H394.38c-3.76,0-6.81,2.72-6.81,6.08S390.62,1132,394.38,1132Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M431.75,1233.35H678c3.76,0,6.81-2.72,6.81-6.08s-3.05-6.08-6.81-6.08H431.75c-3.76,0-6.8,2.72-6.8,6.08S428,1233.35,431.75,1233.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M377.43,1233.35H678c3.76,0,6.81-2.72,6.81-6.08s-3.05-6.08-6.81-6.08H377.43c-3.76,0-6.81,2.72-6.81,6.08S373.67,1233.35,377.43,1233.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1791.62,
    y: 1180.39,
    width: 15.11,
    height: 163.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1735.87,1337.09h126.4a3.08,3.08,0,0,1,3.08,3.08v6.76a0,0,0,0,1,0,0H1733a0,0,0,0,1,0,0v-7A2.86,2.86,0,0,1,1735.87,1337.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1713.55,
    y: 1141.48,
    width: 176.82,
    height: 50.15,
    rx: 17.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1665.25,1294.16s-48.85,21-46,43c0,0,50.49-9.68,59.53-24.11s4-22.79,4-22.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1677.21,1270.11l2.48,21.44a7.09,7.09,0,0,1-4.49,7.53,18.74,18.74,0,0,1-6.19,1,8.28,8.28,0,0,1-8-6l-4.8-17.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1783.91,1105.72s-89.84-4.16-134.54,21.91,2.26,151.2,2.26,151.2,11.68,2.51,28.5-6.48c0,0-24-91.59,17.68-107.53,46.86-17.91,95.33-13.56,95.33-13.56l-9-42.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M1629,1327.55c10.21-2.24,40.5-14.79,45.1-14.62s11.12,7.06,11.12,7.06,1.13,3.77-2.16,9.18c-7.81,6.09-24.62,17.26-44.17,18.49-14.38.9-23-4.82-28-10.38A40,40,0,0,1,1629,1327.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1638.91,1347.66c19.55-1.23,36.36-12.4,44.17-18.49-2.23,3.66-6.46,8.06-14.43,12.56-19.75,11.16-52.4,9.54-58.88,7-5.18-2-3.58-6.85,1.16-11.47C1615.88,1342.84,1624.53,1348.56,1638.91,1347.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M1696,1308.77c-.67,2.53-7.82,10.13-12,14.37a8.13,8.13,0,0,1-7.57,2.27,20.88,20.88,0,0,1-5.42-1.9,5.28,5.28,0,0,1-2-7.18l10.46-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1873,1098.19s7.84,55.63-14.83,67-72.41,18.82-89.54,47.67-47.89,85.49-75.89,101.76c0,0-16-5.2-20.66-13.06,0,0,33.23-87.36,47.09-108.59,12-18.39,29.56-44.88,54.51-56.34,7.14-3.28,7.69-10.86,6.44-18.61l-2.29-14.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1662.8,1035.12c31.79,9.08,46-80.39,45.89-82.56l48.74,57s-29,51.1-72.9,56.54a51.65,51.65,0,0,1-28.44-4.17A45.58,45.58,0,0,0,1662.8,1035.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M1603.93,1005.84c13.86-5.69,25.61,5.67,25.61,5.67,13.73,14,24.62,21.14,33.26,23.61a45.58,45.58,0,0,1-6.71,26.79c-17.13-7.84-27.11-23.71-31.23-31.62a5.94,5.94,0,0,0-7.84-2.66c-2.94,1.42-6,3.58-6.15,6.53-.38,5.8-7.28,6.14-7.32,4s5.34-13.61,5.34-13.61-15.91,10.22-22.11,14.12-11.47-2.54-11.47-2.54S1590.08,1011.53,1603.93,1005.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1860.7,915.74S1818,886.6,1714.81,939.31c0,0-10.62,13.47-5.64,28.65s66.23,97.36,68.61,135.93c0,0,41.87,24.65,96.23.22C1874,1104.11,1892.24,1002.24,1860.7,915.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1771.75,878.48l16.88,33.08a9.41,9.41,0,0,1-1,10.15c-4.65,5.82-14.36,13.65-30.92,8.6a14.48,14.48,0,0,1-9.88-10.52l-8.75-36.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1892.34,1031.26c2.89-20.11-50.25-59.09-50.25-59.09l18.61-56.43s101.4,72.36,80.07,131.45c-3,8.48-7.61,14.65-13.17,19C1916.86,1044.19,1902.3,1035,1892.34,1031.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M1818.21,1036.84s60.1,16.78,72.57-1.51a9.54,9.54,0,0,0,1.56-4.07c10,3.78,24.52,12.93,35.26,35-28.54,22.45-83.57-2.72-98.52-10.26a10.57,10.57,0,0,0-7.92-.66c-5.31,1.66-14.53,4.23-19.66,4-7.51-.41-15.57,26.73-28.36,19.86C1773.14,1079.1,1779,1032.73,1818.21,1036.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M1750.11,824.42c-.54.47-22.8,39.36-34.14,59.19a11.65,11.65,0,0,0,5.54,16.5l4.91,2.1c6.71,2.88,21.14,5.29,26.82.7l35.8-37.78S1762.15,814,1750.11,824.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1799.12,854.82c4.39-2.47,9.67-7.47,5.56-16.3s-12.43-9.76-17.75-9.18a4.46,4.46,0,0,1-4.72-3.21,3.51,3.51,0,0,0-3.11-2.52,4.38,4.38,0,0,1-3.46-5.48c1.28-4.77,1.06-11.26-6.62-15.9-13.62-8.25-26.36,3.73-29.91,14.14s11.74,18.52,21.49,20.18c7.42,1.25,11,9.81,12.35,13.84a4.42,4.42,0,0,1-.52,3.79l-10.89,16.53c3,3.77,5.65,7.75,8.27,11.78,1-1.06,1.83-1.94,2.5-2.55,4.73-4.33,13.13-2.1,16.6-.9a4.36,4.36,0,0,0,3.43-.26c3.77-1.95,11.38-7.42,5.14-17.77A4.46,4.46,0,0,1,1799.12,854.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1765.84,889.55s7-17.88,14.87-16.88,13.83,9.16,3.62,17.64C1771.63,900.86,1765.84,889.55,1765.84,889.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1741.45,1075.11h-.32l-140.42-.15a6.29,6.29,0,1,1,0-12.57l140.43.15a6.29,6.29,0,0,1,.3,12.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1474.47,947.61h117a22.29,22.29,0,0,1,20.16,12.78L1665.64,1075H1520.31a13.56,13.56,0,0,1-12.6-8.57l-41.92-106.08A9.34,9.34,0,0,1,1474.47,947.61Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1548.09,
    cy: 1009.21,
    rx: 9.21,
    ry: 14.98,
    transform: "translate(-234.76 522.87) rotate(-17.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1493.43,1376.29a6,6,0,0,1-2.33-.47,5.65,5.65,0,0,1-3.09-7.5l123.76-278.53a6,6,0,0,1,7.76-3,5.64,5.64,0,0,1,3.08,7.5l-123.75,278.53A5.92,5.92,0,0,1,1493.43,1376.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1632.85,1376.29a5.91,5.91,0,0,1-5.42-3.46L1503.67,1094.3a5.64,5.64,0,0,1,3.09-7.5,6,6,0,0,1,7.75,3l123.76,278.53a5.65,5.65,0,0,1-3.09,7.5A6,6,0,0,1,1632.85,1376.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1876.52,1376.29a6,6,0,0,1-2.33-.47,5.64,5.64,0,0,1-3.09-7.5l123.76-278.53a6,6,0,0,1,7.75-3,5.64,5.64,0,0,1,3.09,7.5l-123.76,278.53A5.92,5.92,0,0,1,1876.52,1376.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2015.93,1376.29a5.92,5.92,0,0,1-5.42-3.46L1886.75,1094.3a5.64,5.64,0,0,1,3.09-7.5,6,6,0,0,1,7.75,3l123.76,278.53a5.64,5.64,0,0,1-3.09,7.5A6,6,0,0,1,2015.93,1376.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2030.45,1081.19a6.75,6.75,0,0,0-1.17-5.15,5.35,5.35,0,0,0-4.3-2.27H1462a6.27,6.27,0,0,0-5.4,3.31,7.89,7.89,0,0,0-.42,6.87l6.1,14.79a8.54,8.54,0,0,0,7.75,5.55h551.11a6.71,6.71,0,0,0,6.35-5.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1205,327.25l4.15-3.62a2.37,2.37,0,0,1,2.84-.08,1.43,1.43,0,0,1,.1,2.31h0l-.08.06-4,3.46-.08.07a2.33,2.33,0,0,1-2.81.07A1.42,1.42,0,0,1,1205,327.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1219.73,316l4.87-2.95a2.4,2.4,0,0,1,2.9.34,1.49,1.49,0,0,1-.42,2.36h0l-.09.05-4.71,2.82-.09.05a2.37,2.37,0,0,1-2.87-.35A1.48,1.48,0,0,1,1219.73,316Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1236.63,306.93l5.41-2.25a2.38,2.38,0,0,1,2.88.76,1.6,1.6,0,0,1-.93,2.34h0l-.09,0-5.25,2.14-.09,0a2.37,2.37,0,0,1-2.85-.76A1.59,1.59,0,0,1,1236.63,306.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1255.13,300.28l5.77-1.51a2.34,2.34,0,0,1,2.78,1.15,1.75,1.75,0,0,1-1.42,2.26h0l-.1,0-5.59,1.43-.1,0a2.32,2.32,0,0,1-2.74-1.16A1.74,1.74,0,0,1,1255.13,300.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1274.68,296.09l6-.76a2.26,2.26,0,0,1,2.6,1.54,1.94,1.94,0,0,1-1.9,2.11h-.12l-5.79.71h-.11a2.22,2.22,0,0,1-2.56-1.53A1.94,1.94,0,0,1,1274.68,296.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1294.81,294.45h6.08a1.94,1.94,0,1,1,0,3.8h-.13l-5.85,0h-.11a1.92,1.92,0,1,1,0-3.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1315,295.45l6,.83a2,2,0,0,1,2,2.26,2.4,2.4,0,0,1-2.78,1.59h0l-.12,0-5.75-.83-.12,0a2,2,0,0,1-1.93-2.24A2.39,2.39,0,0,1,1315,295.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1334.77,299.22l5.74,1.69a1.92,1.92,0,0,1,1.48,2.57,2.67,2.67,0,0,1-3.16,1.21h0l-.12,0-5.47-1.64-.13,0a1.91,1.91,0,0,1-1.45-2.56A2.65,2.65,0,0,1,1334.77,299.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1353.39,305.85c1.76.83,3.5,1.7,5.25,2.55a1.86,1.86,0,0,1,.88,2.83,2.89,2.89,0,0,1-3.47.71h0l-.13-.06c-1.66-.81-3.3-1.65-5-2.45l-.08,0a1.84,1.84,0,0,1-.89-2.8A2.86,2.86,0,0,1,1353.39,305.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1370.13,315.27l4.55,3.31a1.85,1.85,0,0,1,.21,3,3,3,0,0,1-3.67.16h0l-.1-.07-4.32-3.18-.1-.08a1.83,1.83,0,0,1-.19-3A3,3,0,0,1,1370.13,315.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1384.4,327l3.77,3.91a1.92,1.92,0,0,1-.46,3.05,3.11,3.11,0,0,1-3.75-.37v0l-.08-.08-3.57-3.76-.08-.09a1.9,1.9,0,0,1,.48-3A3.08,3.08,0,0,1,1384.4,327Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M1396,340.63l2.9,4.36a2,2,0,0,1-1.1,3,3.08,3.08,0,0,1-3.71-.9h0l-.06-.1-2.74-4.18-.06-.1a2,2,0,0,1,1.12-3A3,3,0,0,1,1396,340.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M1404.57,355.58l2,4.69a2.19,2.19,0,0,1-1.73,2.89,3,3,0,0,1-3.57-1.41h0l0-.11-1.86-4.49,0-.1a2.2,2.2,0,0,1,1.75-2.87A3,3,0,0,1,1404.57,355.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1410.08,371.49l1,4.9a2.43,2.43,0,0,1-2.35,2.68,2.86,2.86,0,0,1-3.3-1.91v0l0-.12-.92-4.67,0-.11a2.42,2.42,0,0,1,2.36-2.65A2.84,2.84,0,0,1,1410.08,371.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M1412.22,388l-.06,5a3,3,0,0,1-5.87-.05h0v-.13l.09-4.72v-.12a2.71,2.71,0,0,1,3-2.33A2.67,2.67,0,0,1,1412.22,388Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1410.71,404.49l-1.19,4.9a3,3,0,0,1-3.53,1.91c-1.63-.26-2.68-1.54-2.36-2.87h0l0-.14,1.17-4.61,0-.14a3,3,0,0,1,3.51-1.88C1410,401.92,1411,403.19,1410.71,404.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1405.33,420.53c-.75,1.55-1.57,3.07-2.35,4.6a3.37,3.37,0,0,1-4,1.35,2.36,2.36,0,0,1-1.65-3.26h0l.07-.13c.75-1.45,1.54-2.89,2.26-4.34l0-.05a3.31,3.31,0,0,1,4-1.37A2.35,2.35,0,0,1,1405.33,420.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M1396.4,435.42l-3.22,4.21a3.6,3.6,0,0,1-4.32.82,2.29,2.29,0,0,1-1-3.51h0l.07-.1,3.11-4,.08-.1a3.55,3.55,0,0,1,4.29-.78A2.26,2.26,0,0,1,1396.4,435.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M1384.88,449l-3.83,3.82a3.71,3.71,0,0,1-4.5.38,2.28,2.28,0,0,1-.46-3.66h0l.07-.06,3.73-3.68.06-.07a3.72,3.72,0,0,1,4.48-.35A2.28,2.28,0,0,1,1384.88,449Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1371.62,461.37l-4.22,3.51a3.81,3.81,0,0,1-4.6,0,2.31,2.31,0,0,1,0-3.74h0l0,0,4.14-3.42,0,0a3.78,3.78,0,0,1,4.58,0A2.3,2.3,0,0,1,1371.62,461.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M1357.28,472.8l-4.42,3.3a3.86,3.86,0,0,1-4.65-.17,2.34,2.34,0,0,1,.2-3.78h0l0,0,4.38-3.25,0,0a3.83,3.83,0,0,1,4.63.18A2.33,2.33,0,0,1,1357.28,472.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M1342.42,483.65l-4.5,3.2a3.89,3.89,0,0,1-4.7-.26,2.37,2.37,0,0,1,.32-3.82h0l4.5-3.17h0a3.89,3.89,0,0,1,4.68.27A2.36,2.36,0,0,1,1342.42,483.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1327.37,494.26l-4.54,3.16a3.92,3.92,0,0,1-4.74-.3,2.39,2.39,0,0,1,.36-3.85l0,0,4.54-3.13a3.92,3.92,0,0,1,4.73.3A2.39,2.39,0,0,1,1327.37,494.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M1312.2,504.75l-4.57,3.13a4,4,0,0,1-4.8-.34,2.42,2.42,0,0,1,.42-3.89v0l4.58-3.1a4,4,0,0,1,4.78.34A2.42,2.42,0,0,1,1312.2,504.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M1296.92,515.14l-4.6,3.09a4,4,0,0,1-4.84-.37,2.45,2.45,0,0,1,.45-3.93l0,0,4.6-3.07a4,4,0,0,1,4.83.38A2.44,2.44,0,0,1,1296.92,515.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M1281.55,525.43l-4.62,3.07a4.07,4.07,0,0,1-4.89-.4,2.48,2.48,0,0,1,.49-4h0l4.63-3.05a4,4,0,0,1,4.87.41A2.47,2.47,0,0,1,1281.55,525.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M1266.11,535.64l-4.64,3.05a4.08,4.08,0,0,1-4.94-.43,2.5,2.5,0,0,1,.52-4h0l4.65-3a4.07,4.07,0,0,1,4.92.44A2.5,2.5,0,0,1,1266.11,535.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1250.62,545.79l-4.66,3a4.11,4.11,0,0,1-5-.45,2.53,2.53,0,0,1,.55-4h0l4.67-3a4.11,4.11,0,0,1,5,.46A2.53,2.53,0,0,1,1250.62,545.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M1235.08,555.89l-4.67,3a4.16,4.16,0,0,1-5-.46,2.57,2.57,0,0,1,.57-4.1h0l4.68-3a4.14,4.14,0,0,1,5,.47A2.55,2.55,0,0,1,1235.08,555.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M1219.51,566l-4.67,3a4.2,4.2,0,0,1-5.09-.48,2.59,2.59,0,0,1,.58-4.14h0l4.69-3a4.2,4.2,0,0,1,5.07.49A2.58,2.58,0,0,1,1219.51,566Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M1203.94,576l-4.67,3a4.26,4.26,0,0,1-5.15-.48,2.62,2.62,0,0,1,.59-4.18h0l4.69-3a4.23,4.23,0,0,1,5.13.49A2.61,2.61,0,0,1,1203.94,576Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M1188.37,586.07l-4.67,3a4.29,4.29,0,0,1-5.2-.48,2.64,2.64,0,0,1,.59-4.22h0l4.69-3a4.29,4.29,0,0,1,5.18.5A2.64,2.64,0,0,1,1188.37,586.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M1172.82,596.13l-4.66,3a4.35,4.35,0,0,1-5.25-.48,2.67,2.67,0,0,1,.58-4.27h0l4.68-3a4.32,4.32,0,0,1,5.23.49A2.66,2.66,0,0,1,1172.82,596.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1157.3,606.23l-4.64,3a4.4,4.4,0,0,1-5.31-.47,2.69,2.69,0,0,1,.57-4.31h0l4.67-3a4.4,4.4,0,0,1,5.29.48A2.7,2.7,0,0,1,1157.3,606.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M1141.84,616.37l-4.63,3a4.44,4.44,0,0,1-5.36-.44,2.72,2.72,0,0,1,.54-4.36h0l4.65-3.05a4.41,4.41,0,0,1,5.34.47A2.71,2.71,0,0,1,1141.84,616.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M1126.44,626.57l-4.61,3.08a4.49,4.49,0,0,1-5.42-.43,2.75,2.75,0,0,1,.53-4.4h0l4.63-3.07a4.46,4.46,0,0,1,5.4.45A2.73,2.73,0,0,1,1126.44,626.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1111.12,636.85l-4.58,3.1a4.52,4.52,0,0,1-5.47-.4,2.76,2.76,0,0,1,.49-4.44v0l4.61-3.09a4.5,4.5,0,0,1,5.45.42A2.76,2.76,0,0,1,1111.12,636.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M1095.9,647.22l-4.54,3.13h0a4.58,4.58,0,0,1-5.53-.37,2.8,2.8,0,0,1,.46-4.49h0l4.57-3.13a4.56,4.56,0,0,1,5.52.39,2.79,2.79,0,0,1-.48,4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1080.8,657.69l-4.5,3.16h0a4.64,4.64,0,0,1-5.59-.33,2.82,2.82,0,0,1,.41-4.54h0l4.54-3.16a4.61,4.61,0,0,1,5.57.34,2.82,2.82,0,0,1-.43,4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M1065.84,668.28l-4.46,3.2h0a4.68,4.68,0,0,1-5.65-.28,2.85,2.85,0,0,1,.35-4.59h0l4.5-3.2a4.64,4.64,0,0,1,5.62.3,2.83,2.83,0,0,1-.36,4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M1051,679l-4.41,3.24h0a4.7,4.7,0,0,1-5.7-.23,2.87,2.87,0,0,1,.29-4.63h0l4.45-3.25a4.71,4.71,0,0,1,5.68.25A2.86,2.86,0,0,1,1051,679Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1036.38,689.88l-4.35,3.3h0a4.77,4.77,0,0,1-5.76-.17,2.9,2.9,0,0,1,.21-4.68h0l4.4-3.3a4.74,4.74,0,0,1,5.73.19,2.88,2.88,0,0,1-.22,4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M1021.94,700.92l-4.3,3.34h0a4.79,4.79,0,0,1-5.8-.1,2.91,2.91,0,0,1,.13-4.71h0l4.33-3.36a4.82,4.82,0,0,1,5.8.12,2.9,2.9,0,0,1-.14,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M1007.69,712.12l-4.23,3.4h0a4.79,4.79,0,0,1-5.81,0,2.92,2.92,0,0,1,0-4.73h0l4.27-3.42a4.8,4.8,0,0,1,5.81,0,2.91,2.91,0,0,1,0,4.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M993.67,723.51,989.52,727h0a4.83,4.83,0,0,1-5.84,0,2.93,2.93,0,0,1-.07-4.74h0l4.19-3.48a4.83,4.83,0,0,1,5.83,0,2.94,2.94,0,0,1,.06,4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M979.92,735.1l-4.06,3.51,0,0a4.85,4.85,0,0,1-5.85.14,2.94,2.94,0,0,1-.18-4.75h0l4.1-3.53a4.83,4.83,0,0,1,5.85-.14,2.94,2.94,0,0,1,.17,4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M966.46,746.9l-4,3.58h0a4.85,4.85,0,0,1-5.86.25,3,3,0,0,1-.3-4.77h0l4-3.61a4.83,4.83,0,0,1,5.85-.24,3,3,0,0,1,.29,4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M953.3,758.92l-3.89,3.65h0a4.86,4.86,0,0,1-5.88.35,3,3,0,0,1-.42-4.77h0l3.93-3.68a4.86,4.86,0,0,1,5.87-.34,3,3,0,0,1,.41,4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M940.47,771.17l-3.78,3.72,0,0a4.85,4.85,0,0,1-5.87.45,3,3,0,0,1-.57-4.77h0l3.82-3.75a4.85,4.85,0,0,1,5.87-.45,3,3,0,0,1,.56,4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M928,783.66l-3.66,3.79,0,0a4.86,4.86,0,0,1-5.88.57,3,3,0,0,1-.71-4.78h0l3.71-3.83a4.86,4.86,0,0,1,5.87-.57,3,3,0,0,1,.7,4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M915.92,796.39l-3.55,3.86,0,0a4.85,4.85,0,0,1-5.87.7,3,3,0,0,1-.86-4.78h0l3.59-3.91a4.89,4.89,0,0,1,5.88-.69,3,3,0,0,1,.85,4.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M904.25,809.36l-3.42,3.94,0,0a4.85,4.85,0,0,1-5.87.83,3,3,0,0,1-1-4.77h0l3.46-4a4.87,4.87,0,0,1,5.87-.82,3,3,0,0,1,1,4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M893,822.58l-3.28,4,0,0a4.84,4.84,0,0,1-5.85,1c-2-1.05-2.48-3.18-1.19-4.76h0l3.32-4.06a4.86,4.86,0,0,1,5.86-1,3.06,3.06,0,0,1,1.17,4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M882.26,836.05l-3.11,4.09,0,0a4.82,4.82,0,0,1-5.83,1.12c-2-1-2.61-3.12-1.38-4.74h0l3.16-4.16a4.83,4.83,0,0,1,5.83-1.12c2,1,2.6,3.12,1.37,4.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M872.2,849.8l-2.84,4.2,0,0a4.79,4.79,0,0,1-5.77,1.36c-2.06-.92-2.81-3-1.67-4.69h0l2.91-4.3a4.8,4.8,0,0,1,5.77-1.36c2.05.92,2.8,3,1.67,4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M863.13,863.93l-2.47,4.33,0,.07A4.71,4.71,0,0,1,855,870c-2.14-.8-3.06-2.86-2.07-4.6h0l2.56-4.47a4.72,4.72,0,0,1,5.66-1.67c2.13.81,3,2.87,2.06,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M855.41,878.51l-2,4.47,0,.1c-.8,1.8-3.26,2.73-5.47,2.07s-3.37-2.64-2.56-4.45h0l2.09-4.66c.81-1.8,3.26-2.72,5.47-2.07s3.36,2.65,2.55,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M849.43,893.55l-1.4,4.59,0,.12c-.57,1.87-2.89,3-5.19,2.55s-3.7-2.35-3.13-4.22h0l1.47-4.83c.57-1.86,2.89-3,5.19-2.54s3.69,2.35,3.12,4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M845.59,909c-.27,1.56-.46,3.11-.67,4.67v.09c-.25,1.92-2.37,3.3-4.73,3.1s-4.07-1.93-3.82-3.85h0c.22-1.66.43-3.32.71-5h0c.33-1.9,2.51-3.23,4.85-3S845.92,907.05,845.59,909Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M844.39,924.55l.22,4.69v.16c.09,1.93-1.76,3.56-4.14,3.63s-4.38-1.44-4.47-3.37h0l-.22-5c-.08-1.93,1.77-3.56,4.15-3.63s4.37,1.45,4.46,3.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M846.14,940.09l1.11,4.59,0,.17c.46,1.91-1.07,3.75-3.41,4.13s-4.61-.87-5.07-2.77h0l-1.18-4.93c-.46-1.9,1.07-3.74,3.41-4.11s4.61.87,5.06,2.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M850.92,955.16l2,4.35.09.18c.85,1.82-.27,3.85-2.51,4.55s-4.74-.22-5.59-2h0l-2.21-4.71c-.85-1.82.27-3.85,2.51-4.54s4.73.22,5.58,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M858.87,969.22l3,3.91.14.19c1.28,1.65.66,3.83-1.37,4.87a5,5,0,0,1-6-1.12h0l-3.3-4.3c-1.27-1.65-.65-3.83,1.38-4.86a5,5,0,0,1,6,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M870.08,981.57l4,3.26.22.18a3.09,3.09,0,0,1,0,5,5.1,5.1,0,0,1-6.16,0h0l-4.42-3.62a3.09,3.09,0,0,1,0-5,5.07,5.07,0,0,1,6.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M884.42,991.48l4.82,2.41.26.13c2,1,2.69,3.21,1.43,4.89a5,5,0,0,1-6,1.16h0l-5.33-2.68c-2.05-1-2.69-3.21-1.42-4.88a5,5,0,0,1,6-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M901.22,998.44l5.38,1.49.26.07c2.29.63,3.52,2.66,2.74,4.52s-3.27,2.86-5.56,2.23h0l-5.91-1.63c-2.29-.64-3.51-2.66-2.73-4.52s3.27-2.86,5.55-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M919.58,1002.36l5.67.61.23,0c2.41.26,4.1,2,3.77,4s-2.53,3.33-4.94,3.07h0l-6.14-.68c-2.4-.26-4.08-2.06-3.76-4s2.54-3.32,4.94-3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M938.66,1003.52l5.77-.12h.19c2.43,0,4.45,1.51,4.51,3.49s-1.86,3.62-4.29,3.67h0l-6.15.12c-2.43.05-4.45-1.52-4.5-3.5s1.86-3.61,4.29-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M957.91,1002.4l5.75-.71.14,0c2.42-.3,4.67,1.05,5,3s-1.29,3.8-3.7,4.09h0l-6,.75c-2.41.29-4.66-1.06-5-3s1.29-3.79,3.7-4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M977,999.44l5.65-1.19.12,0c2.37-.5,4.79.66,5.41,2.59s-.81,3.89-3.18,4.39h0l-5.89,1.24c-2.37.49-4.79-.66-5.4-2.59s.81-3.89,3.18-4.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M995.68,995l5.52-1.59.1,0c2.32-.66,4.86.32,5.68,2.2s-.39,4-2.71,4.62h0l-5.73,1.64c-2.31.66-4.85-.32-5.67-2.2s.4-3.94,2.71-4.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M1013.91,989.27l5.38-1.94.07,0a4.91,4.91,0,0,1,5.88,1.85c1,1.83,0,4-2.27,4.78h0l-5.53,2a4.91,4.91,0,0,1-5.88-1.85c-1-1.83,0-4,2.28-4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M1031.75,982.55l5.28-2.15,0,0a5,5,0,0,1,6,1.63c1.11,1.79.21,4-2,4.87h0l-5.39,2.18a5,5,0,0,1-6-1.63c-1.1-1.79-.21-4,2-4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M1049.24,975.18l5.19-2.32h0a5.06,5.06,0,0,1,6.09,1.43c1.19,1.76.4,4-1.77,5h0l-5.27,2.35a5,5,0,0,1-6.08-1.44c-1.2-1.76-.4-4,1.77-4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M1066.42,967.28l5.1-2.45,0,0a5.1,5.1,0,0,1,6.14,1.28c1.25,1.73.56,4-1.57,5l-5.16,2.5a5.09,5.09,0,0,1-6.14-1.27c-1.27-1.73-.57-4,1.56-5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M1083.33,959l5-2.57h0a5.11,5.11,0,0,1,6.15,1.14c1.3,1.7.68,3.93-1.4,5l-5.06,2.6a5.11,5.11,0,0,1-6.16-1.13c-1.31-1.7-.69-3.94,1.39-5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M1100,950.31l5-2.64h0a5.07,5.07,0,0,1,6.13,1c1.35,1.66.78,3.89-1.27,5l-5,2.67a5.09,5.09,0,0,1-6.15-1c-1.35-1.67-.78-3.91,1.26-5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M1116.54,941.41l4.93-2.7h0a5.09,5.09,0,0,1,6.13,1c1.36,1.64.83,3.87-1.19,5l-5,2.72a5.08,5.08,0,0,1-6.13-1c-1.37-1.64-.84-3.87,1.18-5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M1133,932.35l4.93-2.73a5.05,5.05,0,0,1,6.1.93c1.37,1.63.86,3.84-1.14,5l-4.93,2.74a5,5,0,0,1-6.11-.92,3.19,3.19,0,0,1,1.14-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M1149.41,923.23l4.93-2.74a5,5,0,0,1,6.07.93,3.16,3.16,0,0,1-1.14,4.93l-4.92,2.75a5,5,0,0,1-6.08-.92,3.16,3.16,0,0,1,1.12-4.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M1165.88,914.13l5-2.71a5,5,0,0,1,6,1c1.34,1.62.81,3.81-1.19,4.9h0l-4.94,2.71h0a5,5,0,0,1-6-1,3.16,3.16,0,0,1,1.17-4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M1182.48,905.14l5-2.66a5,5,0,0,1,6,1c1.3,1.63.75,3.8-1.25,4.87h0l-5,2.66h0a5,5,0,0,1-6-1c-1.31-1.62-.76-3.8,1.24-4.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M1199.21,896.32l5-2.61a4.94,4.94,0,0,1,5.94,1.08c1.27,1.63.68,3.79-1.32,4.82h0l-5,2.6h0a4.94,4.94,0,0,1-5.95-1.07c-1.28-1.63-.69-3.79,1.31-4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M1216.09,887.69l5.1-2.55a4.88,4.88,0,0,1,5.89,1.14c1.24,1.63.61,3.77-1.4,4.78h0l-5.06,2.54h0a4.89,4.89,0,0,1-5.9-1.13c-1.25-1.64-.63-3.78,1.39-4.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M1233.14,879.26l5.15-2.48a4.85,4.85,0,0,1,5.84,1.2c1.2,1.65.53,3.77-1.49,4.75h0l-5.11,2.48h0a4.86,4.86,0,0,1-5.85-1.2c-1.21-1.65-.55-3.77,1.48-4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M1250.37,871.06l5.2-2.41a4.8,4.8,0,0,1,5.78,1.28c1.16,1.66.45,3.76-1.58,4.7h0l-5.16,2.4h0a4.81,4.81,0,0,1-5.79-1.28c-1.17-1.65-.46-3.76,1.57-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M1267.78,863.11l5.26-2.33a4.75,4.75,0,0,1,5.71,1.37c1.12,1.66.37,3.74-1.68,4.65h0l-5.21,2.32h0a4.75,4.75,0,0,1-5.73-1.36c-1.12-1.66-.38-3.74,1.67-4.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M1285.38,855.44l5.32-2.24a4.7,4.7,0,0,1,5.65,1.45c1.07,1.67.27,3.73-1.79,4.6h0l-5.26,2.24h0a4.71,4.71,0,0,1-5.66-1.45c-1.07-1.67-.28-3.73,1.78-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1303.18,848.07l5.39-2.14a4.63,4.63,0,0,1,5.58,1.55c1,1.68.16,3.71-1.91,4.53h0l-5.32,2.14h0a4.64,4.64,0,0,1-5.59-1.55c-1-1.68-.17-3.71,1.9-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M1321.2,841l5.44-2a4.6,4.6,0,0,1,5.51,1.65c1,1.69,0,3.7-2,4.48h0l-5.38,2,0,0a4.6,4.6,0,0,1-5.52-1.65c-1-1.69-.06-3.7,2-4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1339.42,834.36l5.51-1.93a4.54,4.54,0,0,1,5.43,1.75c.9,1.71-.07,3.68-2.16,4.41h0l-5.45,1.92h0a4.55,4.55,0,0,1-5.43-1.75c-.91-1.7,0-3.68,2.15-4.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M1357.87,828.07l5.57-1.8a4.48,4.48,0,0,1,5.34,1.86c.83,1.72-.19,3.66-2.3,4.34h0l-5.51,1.79h0a4.48,4.48,0,0,1-5.35-1.86c-.84-1.71.18-3.66,2.29-4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M1376.54,822.22l5.64-1.66a4.36,4.36,0,0,1,5.19,2c.76,1.7-.32,3.58-2.4,4.21h0l-5.56,1.67h0a4.38,4.38,0,0,1-5.23-2c-.78-1.71.3-3.62,2.41-4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M1395.43,816.85l5.71-1.51c2.09-.56,4.34.37,5,2.07s-.44,3.52-2.52,4.08h0L1398,823h0c-2.1.57-4.37-.35-5.07-2.06s.43-3.55,2.53-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M1414.53,812l5.77-1.36c2.08-.49,4.25.48,4.86,2.17s-.59,3.45-2.65,4h0l-5.68,1.37h0c-2.09.5-4.28-.46-4.9-2.16s.57-3.48,2.65-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M1433.83,807.64l5.81-1.19c2.07-.42,4.17.59,4.69,2.27s-.73,3.37-2.77,3.8h0l-5.72,1.2h0c-2.08.44-4.19-.57-4.73-2.26s.71-3.4,2.78-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M1453.3,803.87l5.88-1c2-.35,4.06.71,4.5,2.37s-.86,3.29-2.9,3.65h0l-5.79,1h0c-2.05.37-4.09-.69-4.54-2.36s.85-3.32,2.91-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M1473,800.7l5.93-.83c2-.28,3.95.82,4.3,2.47s-1,3.2-3,3.49h0l-5.83.85h0c-2,.3-4-.8-4.35-2.46s1-3.23,3-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M1492.75,798.17l6-.63c2-.21,3.84.94,4.1,2.57s-1.14,3.1-3.13,3.32h0l-5.87.65h0c-2,.22-3.87-.93-4.14-2.56s1.13-3.14,3.14-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M1512.66,796.31l6-.42c2-.14,3.72,1.05,3.89,2.66s-1.28,3-3.25,3.15h0l-5.9.45h0c-2,.15-3.75-1-3.94-2.65s1.28-3,3.26-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M1532.65,795.15l6-.2c1.94-.07,3.59,1.16,3.67,2.74s-1.42,2.91-3.35,3h0l-5.91.24h0c-2,.08-3.62-1.15-3.72-2.74s1.41-2.94,3.37-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M1552.7,794.73l6,0c1.91,0,3.45,1.29,3.43,2.84s-1.57,2.79-3.47,2.79h-6c-1.92,0-3.47-1.27-3.47-2.84s1.56-2.82,3.49-2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M1572.82,795.28l6,.41c1.87.13,3.25,1.47,3.09,3s-1.79,2.64-3.64,2.52h-.1l-5.85-.37h-.09c-1.88-.12-3.29-1.46-3.14-3s1.79-2.67,3.67-2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M1592.9,797.23l6,.94c1.8.28,3,1.7,2.63,3.17a3.33,3.33,0,0,1-3.87,2.14h-.12l-5.76-.87-.11,0c-1.82-.27-3-1.69-2.68-3.17s2.08-2.45,3.9-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M1612.65,801.09l5.78,1.6c1.71.47,2.62,2,2,3.36a3.47,3.47,0,0,1-4.11,1.66l-.15,0-5.51-1.49-.14,0c-1.72-.47-2.65-2-2.08-3.37a3.49,3.49,0,0,1,4.15-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M1631.56,807.32l5.38,2.41a2.34,2.34,0,0,1,1.25,3.49,3.56,3.56,0,0,1-4.26,1l-.16-.07-5.1-2.21-.16-.07a2.37,2.37,0,0,1-1.31-3.52,3.59,3.59,0,0,1,4.32-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M1648.78,816.3l4.72,3.22a2.17,2.17,0,0,1,.37,3.48,3.56,3.56,0,0,1-4.26.33l-.14-.1-4.48-3-.14-.09a2.21,2.21,0,0,1-.43-3.53,3.59,3.59,0,0,1,4.33-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M1663.47,827.92l3.76,4a2.09,2.09,0,0,1-.53,3.33,3.39,3.39,0,0,1-4.08-.41l-.13-.13-3.57-3.68-.12-.13a2.11,2.11,0,0,1,.49-3.38,3.45,3.45,0,0,1,4.16.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M1674.56,842l2.41,4.64a2.14,2.14,0,0,1-1.49,3,3.08,3.08,0,0,1-3.66-1.18l-.1-.18-2.29-4.27-.1-.17a2.17,2.17,0,0,1,1.47-3,3.12,3.12,0,0,1,3.74,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M1680.65,858l.7,5a2.35,2.35,0,0,1-2.37,2.42,2.61,2.61,0,0,1-3-1.9l0-.18-.72-4.63,0-.18a2.36,2.36,0,0,1,2.36-2.48,2.67,2.67,0,0,1,3.05,1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M1681,874.71l-1,4.95a2.56,2.56,0,0,1-3,1.73,2.19,2.19,0,0,1-2.13-2.37l0-.15.85-4.64,0-.16a2.59,2.59,0,0,1,3-1.79,2.24,2.24,0,0,1,2.2,2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M1676.11,890.84l-2.26,4.61a2.67,2.67,0,0,1-3.19,1.11,1.9,1.9,0,0,1-1.38-2.57l0-.1,2.09-4.42,0-.1a2.69,2.69,0,0,1,3.22-1.17,1.93,1.93,0,0,1,1.43,2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M1667.51,905.75l-3.1,4.23a2.66,2.66,0,0,1-3.21.66,1.72,1.72,0,0,1-.82-2.59l0-.06,2.95-4.13,0-.07a2.71,2.71,0,0,1,3.25-.7,1.75,1.75,0,0,1,.86,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M1656.51,919.46l-3.62,3.92a2.6,2.6,0,0,1-3.12.36,1.59,1.59,0,0,1-.45-2.51l0,0,3.5-3.88,0,0a2.61,2.61,0,0,1,3.16-.4,1.63,1.63,0,0,1,.48,2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M1644,932.22l-3.94,3.68a2.46,2.46,0,0,1-3,.17,1.5,1.5,0,0,1-.23-2.4l0,0,3.84-3.67,0,0a2.5,2.5,0,0,1,3-.2,1.52,1.52,0,0,1,.24,2.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M1630.67,944.3l-4.14,3.56a2.33,2.33,0,0,1-2.81.07,1.42,1.42,0,0,1-.09-2.28h0l4.06-3.57h0a2.37,2.37,0,0,1,2.86-.1,1.45,1.45,0,0,1,.12,2.33Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness3);
export default __webpack_public_path__ + "static/media/business_3.16367c11d39bb15ec853d37078dd2b14.svg";
export { ForwardRef as ReactComponent };